import React from 'react';
import { AlertTriangle, RefreshCw, HelpCircle } from 'lucide-react';

export default function DemoBanner({ onRestartTour }) {
  const handleRestartTour = () => {
    localStorage.removeItem('demo_tour_completed');
    if (onRestartTour) {
      onRestartTour();
    } else {
      // Reload to trigger tour
      window.location.reload();
    }
  };

  return (
    <div className="bg-gradient-to-r from-amber-500 to-orange-500 text-white px-4 py-2.5 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-2 text-sm">
        <div className="flex items-center gap-2">
          <AlertTriangle className="w-4 h-4 flex-shrink-0" />
          <span className="font-semibold">Demo Mode</span>
        </div>
        <span className="hidden sm:inline">•</span>
        <div className="flex items-center gap-1.5 text-amber-100">
          <RefreshCw className="w-3.5 h-3.5" />
          <span>All changes will be reset when you log out</span>
        </div>
        <span className="hidden sm:inline">•</span>
        <button 
          onClick={handleRestartTour}
          className="flex items-center gap-1.5 text-white hover:text-amber-100 transition-colors bg-white/20 hover:bg-white/30 px-2.5 py-1 rounded-full text-xs font-medium"
        >
          <HelpCircle className="w-3.5 h-3.5" />
          <span>Tour</span>
        </button>
      </div>
    </div>
  );
}
